define.alias("ember-power-select/helpers/ember-power-select-is-selected-present", "calendar/helpers/ember-power-select-is-selected-present");